module.exports = __webpack_public_path__ + "static/media/gallery28.3dec2b97.jpeg";